// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTos";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

// XNG-Changes: FLIP-773 this customization done for Change Customer page 
// only to pass the property to api
export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const apiParameter = { ...props.parameter } as any;
    const isChangeCustomerPage = getCurrentPage(props.getState()).type === "ChangeCustomerPage";

    if (isChangeCustomerPage) {
        apiParameter.IsChangeCustomerPage = 1;
    }

    props.apiParameter = apiParameter;
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
